import React from 'react';

const IOT = () => {
    return (
        <>
            <div className="breadcrumb-area">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadcrumb_box text-center">
                                <h2 className="breadcrumb-title">IoT Applications</h2>
                                <ul className="breadcrumb-list">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item"><a href="/technologies">Technologies</a></li>
                                    <li className="breadcrumb-item active">IoT Applications</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="service-details-wrapper section-space--ptb_100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="content-area">
                                <div className="service-details-content">
                                    <h1>IoT Solutions: Connected Intelligence</h1>
                                    
                                    <p className="lead">We develop comprehensive Internet of Things (IoT) solutions that connect, monitor, and control physical devices at scale. From smart homes to industrial automation, our end-to-end platform enables the connected future.</p>

                                    <h3 className="mt-50">The Connected Future is Now</h3>
                                    <p>IoT bridges the physical and digital worlds by connecting billions of devices. Our expertise spans embedded systems, cloud integration, real-time analytics, and secure device management.</p>

                                    <h3 className="mt-40">Complete IoT Capabilities</h3>
                                    <ul>
                                        <li><strong>Embedded Systems Development:</strong> Firmware for microcontrollers and IoT devices</li>
                                        <li><strong>Sensor Integration:</strong> Connect diverse sensors and actuators</li>
                                        <li><strong>Real-Time Data Collection:</strong> High-frequency device telemetry</li>
                                        <li><strong>Cloud Connectivity:</strong> MQTT, CoAP, and custom protocols</li>
                                        <li><strong>Edge Computing:</strong> Local processing and intelligence</li>
                                        <li><strong>Data Analytics:</strong> Machine learning on device data</li>
                                        <li><strong>Visualization & Dashboards:</strong> Real-time monitoring platforms</li>
                                        <li><strong>Security & Privacy:</strong> Encryption, authentication, and compliance</li>
                                    </ul>

                                    <h3 className="mt-40">Real-World IoT Applications</h3>
                                    <p><strong>Smart Homes & Buildings:</strong> Automated HVAC, lighting, and security systems.</p>
                                    <p><strong>Industrial IoT (IIoT):</strong> Manufacturing, predictive maintenance, and supply chain tracking.</p>
                                    <p><strong>Healthcare & Wearables:</strong> Remote patient monitoring, fitness trackers, and medical devices.</p>

                                    <h3 className="mt-40">AppCore's IoT Excellence</h3>
                                    <div className="case-study-box mt-30">
                                        <h5>Success: Industrial Predictive Maintenance Platform</h5>
                                        <p>We built an IoT platform for manufacturing:</p>
                                        <ul>
                                            <li>🏭 500+ connected industrial sensors</li>
                                            <li>📊 Real-time anomaly detection with ML</li>
                                            <li>⚡ Reduced downtime by 35%</li>
                                            <li>💰 $2M annual cost savings</li>
                                        </ul>
                                    </div>

                                    <h3 className="mt-40">IoT Implementation Patterns</h3>
                                    <ul>
                                        <li>Device provisioning and management</li>
                                        <li>Secure firmware update over-the-air (OTA)</li>
                                        <li>Time-series data storage and retrieval</li>
                                        <li>Real-time alerting and notifications</li>
                                        <li>Device-to-device communication</li>
                                        <li>Edge computing and local intelligence</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="sidebar-area">
                                <div className="sidebar-widget mb-50">
                                    <h5 className="widget-title mb-30">IoT Capabilities</h5>
                                    <ul className="sidebar-list">
                                        <li>🔌 Device Integration</li>
                                        <li>📊 Real-Time Analytics</li>
                                        <li>🌐 Cloud Connectivity</li>
                                        <li>⚡ Edge Computing</li>
                                        <li>🔒 End-to-End Security</li>
                                        <li>📱 Mobile Dashboards</li>
                                    </ul>
                                </div>

                                <div className="sidebar-widget">
                                    <h5 className="widget-title mb-30">Project Impact</h5>
                                    <div className="metric-item mb-20">
                                        <p className="metric-label">IoT Projects</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>15+</p>
                                    </div>
                                    <div className="metric-item mb-20">
                                        <p className="metric-label">Connected Devices</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>50k+</p>
                                    </div>
                                    <div className="metric-item">
                                        <p className="metric-label">Uptime</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>99.9%</p>
                                    </div>
                                </div>

                                <div className="sidebar-widget mt-50">
                                    <h5 className="widget-title mb-30">Connected Innovation</h5>
                                    <p className="small">From smart homes to industrial automation, our IoT expertise delivers connected solutions that drive efficiency and innovation across industries.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default IOT;
